import React from "react";
import Div from "../Div";
import SocialWidget from "../Widget/SocialWidget";
import TextWidget from "../Widget/TextWidget";
import "./footer.scss";

export default function Footer({ copyrightText, logoSrc, logoAlt, text }) {
  return (
    <footer className="cs-footer">
       {/* <Div className="container">
          <Div className="cs-bottom_footer">
            <Div className="cs-bottom_footer_left">
              <Div className="cs-copyright">
              <MenuWidget menuItems={copyrightLinks} variant=" cs-style2" />


              </Div>
            </Div>
            <Div className="cs-bottom_footer_right">
            </Div>
          </Div>
        </Div> */}
      <Div className="cs-footer_main">
       
        <Div className="container">
          <Div className="row">
            <Div className="col-lg-6 col-sm-6">
              <Div className="cs-footer_item footer-logo">
                <TextWidget
                  logoSrc="/images/footer-logo.svg"
                  logoAlt="Logo"
                  text=""
                />

                <Div className="cs-copyright">
                  © 2026 Dreamscript Technologies, All rights reserved.
                </Div>
              </Div>
            </Div>

            <Div className="col-lg-6 col-sm-6">
              <Div className="cs-footer_item">
                <SocialWidget />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
    </footer>
  );
}
